import React, { useEffect, useRef, useState } from "react";
import AuthScreensLayout from "../../../components/resusable/layout/authScreensLayout";
import { Col, Row } from "react-bootstrap";
import InputField from "../../../components/resusable/inputField/InputField";
import ButtonComponent from "../../../components/resusable/button/authButton";
import { Link, useNavigate } from "react-router-dom";
import utils from "../../../utils/utils";
import "./update-profile.css";
import SelectField from "../../../components/login/selectField/selectField";
import { useDispatch } from "react-redux";
import { _addUserName } from "../../../redux/actions/authAction";
import { errorRequestHandel, isValidEmailAddress } from "../../../helper";
import PasswordField from "../../../components/resusable/inputField/passwordField";
import {
  _getCoutriesList,
  _updateWorkspaceName,
  _userProfileData,
  updateProfile,
} from "../../../components/https/settings/profileSettings";
import { message } from "antd";
import CustomPrimaryButton from "../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import useIsAdmin from "../../../hooks/useIsAdmin";
import { _setMyOrganizationData } from "../../../redux/actions/generalAction";
import { _addUserProfileData } from "../../../redux/actions/profileSettingsAction";

function UpdateWorkSpace() {
  const isAdmin = useIsAdmin();
  const userdata = JSON.parse(localStorage.getItem("user"));

  const [formData, setFormData] = useState({
    name: userdata?.organization?.name,
  });

  const [errors, setErrors] = useState({
    name: "",
  });

  const inputRefs = {
    name: useRef(null),
  };

  const dispatch = useDispatch();

  const handleInputFocus = (fieldName) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));
  };

  const [loading, setLoading] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const handleUpdateProfile = async () => {
    const updatedValues = { ...formData };

    if (formData.name === "") {
      setErrors({
        name: "This field is required",
      });
      inputRefs.name.current.scrollIntoView({ behavior: "smooth" });
      return;
    }

    if (formData.name === "") {
      setErrors({ ...errors, name: "This field is required" });
      inputRefs.name.current.scrollIntoView({ behavior: "smooth" });
      return;
    }

    try {
      setLoading(true);
      const response = await _updateWorkspaceName({ payload: updatedValues });
      if (response.status === 200) {
        message.success("Updated successfully");
        dispatch(_setMyOrganizationData(response.data.data));
        await userProfileData();
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  const userProfileData = async () => {
    try {
      const response = await _userProfileData();
      if (response.status === 200) {
        dispatch(_addUserProfileData(response.data.data));
        localStorage.setItem("user", JSON.stringify(response.data.data));
      }
    } catch (error) {
      errorRequestHandel({ error: error });
    }
  };
  return (
    <AuthScreensLayout
      cloudImage={utils.images.cloudBased}
      cloudHeading="Cloud Based"
      cloudDescription="Promotes access to information at the point of care. Improves the process of analysis and decision
    making."
      imageWidth={200}
    >
      <Row>
        <Col md={8}>
          <div className="update_profile_container">
            <img
              src={utils.icons.Dentalid_logo}
              height={17}
              width={200}
              alt="logo"
              onClick={() => navigate("/")}
            />
            <h4>Update Workspace</h4>
            <p>Access and update your Workspace name</p>
            <br />
            <br />
            <br />
            <div ref={inputRefs.firstName}>
              <InputField
                loading={loading}
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Workspace Name"
                type="text"
                icon={utils.icons.licenseIcon}
                fieldError={errors.name}
                handleInputFocus={() => handleInputFocus("name")}
              />
            </div>
            {/* <div ref={inputRefs.country}>
              <SelectField
                name="country"
                value={formData.country}
                onChange={handleInputChange}
                loading={loading}
                placeholder={userdata?.country?.nice_name}
                type="text"
                icon={utils.icons.countryIcon}
                fieldError={errors.country}
                handleInputFocus={() => handleInputFocus('country')}
                specialityOptions={countriesListing}
              />
            </div>

            <div ref={inputRefs.speciality}>
              <SelectField
                name="speciality"
                value={formData.speciality}
                onChange={handleInputChange}
                loading={loading}
                placeholder={userdata?.speciality?.value}
                type="text"
                icon={utils.icons.dentistIcon}
                fieldError={errors.speciality}
                handleInputFocus={() => handleInputFocus('speciality')}
                specialityOptions={specialityOptions}
              />
            </div> */}
            {/* <div ref={inputRefs.license_number}>
              <InputField
                loading={loading}
                name="license_number"
                value={formData.license_number}
                onChange={handleInputChange}
                placeholder="License Number"
                icon={utils.icons.licenseIcon}
                fieldError={errors.license_number}
                handleInputFocus={() => handleInputFocus("license_number")}
              />
            </div> */}
            <div>
              <CustomPrimaryButton
                title="Save Changes"
                onClick={handleUpdateProfile}
                width={"100%"}
                isLoading={loading}
              />
            </div>
          </div>
        </Col>
      </Row>
    </AuthScreensLayout>
  );
}

export default UpdateWorkSpace;
